module.exports = __webpack_public_path__ + "static/media/icon-loading-success.218adecc.svg";